// extracted by mini-css-extract-plugin
export default {"root":"uag7ua","line":"HA_OJI"};